import { addHashedData } from "./addHashedData.es.js";
import { extractApplicationData } from "./extractApplicationData.es.js";
import { extractClickData } from "./extractClickData.es.js";
import { extractEventData } from "./extractEventData.es.js";
import { extractExperiments } from "./extractCommonPayload.es.js";
import { extractIds } from "./extractIds.es.js";
import { extractMetaTags } from "./extractMetaTags.es.js";
import { extractMktgIds } from "./extractMktgIds.es.js";
import { extractUrlData } from "./extractUrlData.es.js";
import { extractUserConsent } from "./extractUserConsent.es.js";
import { extractUserDeviceData } from "./extractUserDeviceData.es.js";
import { getFormData } from "./extractFormData.es.js";
import { g as getTealiumIds } from "../../../getTealiumIds-c24d3498.js";
import { p as pkg } from "../../../package-7dcca52d.js";
import { v as videoData } from "../../../videoData-64ad3ea2.js";
import { v as v4 } from "../../../v4-88c20f3b.js";
import "./hashUtils.es.js";
import "../../constants/analytics.es.js";
import "./pageUtils.es.js";
import "../../constants/profileFields.es.js";
import "../../../pickFields-27454ddf.js";
import "../../../analytics-plugin-original-source.browser.es-e6f690eb.js";
import "./getUtmParams.es.js";
import "../../../mapKeys-251205e5.js";
import "./getBrowserID.es.js";
import "../../../cookies-04bd2321.js";
import "../../../utils/logger.es.js";
import "../../../_commonjsHelpers-7a77ea84.js";
import "../../../server/validation/defaultSchema.es.js";
import "../../../waitFor-1b67bbb8.js";
const generateFreedomPayload = async (payload, eventName, eventAction, { application, shouldExtractApplicationData }) => {
  var _a, _b, _c, _d, _e;
  const applicationData = {
    page_name: (_a = payload == null ? void 0 : payload.properties) == null ? void 0 : _a.page_name,
    ...shouldExtractApplicationData ? extractApplicationData(payload) : (_b = payload == null ? void 0 : payload.properties) == null ? void 0 : _b.application_data
  };
  const hashedData = await addHashedData(applicationData);
  let freedomFormData = {};
  if ((_c = payload == null ? void 0 : payload.properties) == null ? void 0 : _c.form) {
    ({ freedomFormData } = await getFormData((_d = payload == null ? void 0 : payload.properties) == null ? void 0 : _d.form));
  }
  const appData = { ...applicationData, ...hashedData };
  const clickData = extractClickData(payload.properties, application);
  const extractedId = await extractIds(payload);
  const mktgIds = extractMktgIds();
  const tealiumData = await getTealiumIds();
  const video = videoData(payload);
  return {
    referrer: ((_e = payload == null ? void 0 : payload.properties) == null ? void 0 : _e.referrer) || null,
    ...extractEventData(payload, application),
    app_event_horizon_version: pkg.version,
    application_data: appData,
    application_data_string: JSON.stringify(appData),
    ...clickData,
    event_action: eventAction,
    event_datetime: payload.meta.ts,
    event_id: v4(),
    event_name: eventName,
    experiments: extractExperiments(payload),
    form: freedomFormData,
    ...video && { video },
    ids: { ...extractedId, ...tealiumData },
    lead_stage: payload.properties.lead_stage || null,
    lead_type: payload.properties.lead_type || null,
    meta_tags: {
      ...extractMetaTags(payload)
    },
    ...mktgIds && { mktg_ids: mktgIds },
    page_view_id: payload.properties.page_view_id,
    time_since_last_event: payload.properties.time_since_last_event,
    url_data: {
      ...extractUrlData(payload)
    },
    user_consent: {
      ...extractUserConsent(payload)
    },
    user_device_data: {
      ...extractUserDeviceData(payload)
    }
  };
};
export {
  generateFreedomPayload
};
